<template>
    <v-card class="core_card" variant="flate" style="height: 100%;overflow-y: auto !important;">
        <v-row>
            <div class="d-flex justify-space-between align-center pl-5 pb-0 mb-0" style="width: 100% !important;">
              <div class="d-flex align-center justify-center">
                <v-col cols="12" class="py-0 d-flex align-center ga-5">
                    <h2 class="card_title mb-0">Know your Product</h2>
                    <TemplateDownload v-if="role < 6" :data="excelTemplate" text="KnowYourProduct"/>
                    <v-btn v-if="role < 6" class="ml-3" color="primary" variant="outlined" @click="startSync">
                        <v-icon left :class="{ 'rotating': isSyncing }">mdi-sync</v-icon>
                        {{ isSyncing ? 'Syncing' : 'Sync' }}
                    </v-btn>
                </v-col>
                <!-- <v-col cols="2">
                </v-col> -->
                <!-- <transition name="fade">
                    <div
                      v-if="isSyncing"
                      class="syncing-text ml-3"
                    >
                      Syncing<span class="dots">{{ dots }}</span>
                    </div>
                </transition> -->
              </div>
          
              <div class="pr-5">
                <ExcelUpload v-if="role < 6" :showCard="'customer'" @uploaded="getData" />
              </div>
            </div>
         
            <!-- <v-col cols="12">
                <v-card variant="flate" class="product_card">
                    <h2 class="sub_title">Department</h2>
                    <v-list v-for="(value, index) in department" v-bind:key="index" style="width: 60%;" class="content_text">{{ value }}</v-list>
                </v-card>
            </v-col> -->
            <v-col cols="3" >

                <v-card variant="flate" class="product_card" >
                    <h2 class="sub_title">Divisions</h2>
                    <div class="mt-1 ml-2">
                        <v-list v-for="(value, index) in division" v-bind:key="index" class="content_text">{{ value }}</v-list>
                        <!-- <v-list class="content_text">Sezzit</v-list> -->
                    </div>
                </v-card>
                <v-card  variant="flate" class="product_card mt-4" style="height: 500px;">
                    <h2 class="sub_title">SBU</h2>
                    <div class="mt-1 ml-2">
                        <v-list v-for="(value, index) in sbu" v-bind:key="index" class="content_text">{{ value }}</v-list>
                        <!-- <v-list class="content_text">Sezzit</v-list> -->
                    </div>
                </v-card>
            </v-col>
            <v-col cols="3">
                <v-card  variant="flate" class="product_card pb-8">
                    <h2 class="sub_title">Commodity</h2>
                    <div class="mt-1 ml-2" >
                        <v-list v-for="(value, index) in commodity" v-bind:key="index" class="content_text">{{ value }}</v-list>
                        <!-- <v-list class="content_text">Sezzit</v-list> -->
                    </div>
                </v-card>
                <v-card  variant="flate" class="product_card mt-6">
                    <h2 class="sub_title">Product Line</h2>
                    <div class="mt-1 ml-2">
                        <v-list v-for="(value, index) in product_line" v-bind:key="index" class="content_text">{{ value }}</v-list>
                        <!-- <v-list class="content_text">Sezzit</v-list> -->
                    </div>
                </v-card>
            </v-col>
            <v-col cols="3">
                <v-card  variant="flate" class="product_card" style="height: 100% !important;">
                    <h2 class="sub_title">Licensor</h2>
                    <div class="mt-1 ml-2">
                        <v-list v-for="(value, index) in licensor" v-bind:key="index" class="content_text">{{ value }}</v-list>
                        <!-- <v-list class="content_text">Sezzit</v-list> -->
                    </div>
                </v-card>
            </v-col>
            <!-- <v-col cols="3">
                <v-col cols="12">
                    <img :src="require('@/assets/product_1.png')" alt="">
                </v-col>
                <v-col cols="12">
                    <img :src="require('@/assets/product_2.png')" alt="">
                </v-col>

            </v-col> -->
        </v-row>
    </v-card>
    <!-- <v-dialog v-model = "inprogress">
        <v-card>
            inprogress...
        </v-card>
    </v-dialog> -->
</template>

<script>
import ExcelUpload from '@/menus/ExcelUpload.vue';
import TemplateDownload from '@/menus/TemplateDownload.vue';
import clientDetailsService from '@/api/service/ClientDetails/ClientDetailsService';

export default{
    components:{
        ExcelUpload,
        TemplateDownload,
    },
    data:()=>({
       department : [],
       division :[],
       organisationData:[],
       sbu : [],
       commodity:[],
       licensor:[],
       product_line:[],
       role:null,
       excelTemplate:['description','department','division','sbu','commodity','licensor','product_line'],
    //    inprogress: false
       isSyncing: false,
    //   dots: "",
    //   dotInterval: null,
    }),
      created() {
        this.getOrganisation();
        let user = localStorage.getItem('user_details')
        user = JSON.parse(user)
        this.role = user.roles.role_type
    },
    methods:{
        startSync() {
          this.isSyncing = true;
        //   let count = 0;           
        //   this.dotInterval = setInterval(() => {
        //     count = (count + 1) % 4;
        //     this.dots = ".".repeat(count);
        //   }, 500);

        //   setTimeout(() => {
        //     this.isSyncing = false;
        //     clearInterval(this.dotInterval);
        //     this.dots = "";
        //   }, 5000);
          setTimeout(() => {
        this.isSyncing = false;
      }, 4000);
        },
        async getOrganisation() {
            let $id = this.$route.query.id
            this.organisationData = await clientDetailsService.findOne({ id: $id, collectionName: 'organisation' })
            this.department = this.organisationData && this.organisationData.product && this.organisationData.product.department ? this.organisationData.product.department : []
            this.division = this.organisationData && this.organisationData.product && this.organisationData.product.division ? this.organisationData.product.division : []
            this.sbu = this.organisationData && this.organisationData.product && this.organisationData.product.sbu ? this.organisationData.product.sbu : []
            this.commodity = this.organisationData && this.organisationData.product && this.organisationData.product.commodity ? this.organisationData.product.commodity : []
            this.licensor = this.organisationData && this.organisationData.product && this.organisationData.product.licensor ? this.organisationData.product.licensor : []
             this.product_line = this.organisationData && this.organisationData.product && this.organisationData.product.product_line ? this.organisationData.product.product_line : []
        },
        async getData(value) {
            console.log(value,"vall");
            if(value && value.length >0){
                for(let i of value){
                    console.log(i,"loop");
                    if(i.department){
                        this.department.push(i.department)
                    }
                    if(i.division){
                        this.division.push(i.division)
                    }
                    if(i.sbu){
                        this.sbu.push(i.sbu)
                    }                    
                    if(i.commodity){
                        this.commodity.push(i.commodity)
                    }                    
                    if(i.licensor){
                        this.licensor.push(i.licensor)
                    }                    
                    if(i.product_line){
                        this.product_line.push(i.product_line)
                    }
                }
                this.saveAllData()
            }
            console.log(this.department,"1111");
            console.log(this.division,"1111");
            console.log(this.sbu,"1111");
            console.log(this.commodity,"1111");
            console.log(this.licensor,"1111");
            console.log(this.product_line,"1111");

        },
         async saveAllData() {
            this.organisationData.product = {
                department: this.department,
                division: this.division,
                sbu: this.sbu,
                commodity: this.commodity,
                licensor: this.licensor,
                product_line: this.product_line,
            }
            let $data = {
                collectionName: 'organisation',
                data: this.organisationData,
                id: this.$route.query.id
            }
            await clientDetailsService.update($data)
        },
    }
}


</script>


<style>
.core_card {
    background-color: #FEFEFE;
    padding: 20px;
}

.card_title {
    font-size: 20px;
    font-weight: 600;
}

.product_card {
    background-color: #F2F2F2;
    padding: 20px;
}

.content_text {
    font-size: 14px;
    font-weight: 400;
    background-color: #F2F2F2;
}

.sub_title {
    font-size: 14px;
    font-weight: 700;
}
/* .syncing-text {
  font-size: 16px;
  font-weight: 500;
  color: #1976d2;
  transition: opacity 0.3s ease-in-out;
} */

/* Fade transition */
/* .fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
} */
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
.rotating {
  animation: spin 1s linear infinite;
}
</style>